import { useQuery } from "@tanstack/react-query";

import useApi from "$src/core/hooks/use-api";

const queryKey = () => ["search-recommendations"];

const useSearchRecommendationsQuery = (options?: { enabled?: boolean }) => {
  const { api } = useApi();

  return useQuery({
    queryKey: queryKey(),
    queryFn: () => api.getSearchRecommendations(),
    ...options,
  });
};

export default useSearchRecommendationsQuery;
